import { isBefore, startOfToday } from 'date-fns';

import type Validator from '../../models/Validator';

const FutureDateValidator: Validator = class {
  static isValid(value) {
    return !isNaN(Date.parse(value)) && !isBefore(value, startOfToday());
  }

  static getError() {
    return null;
  }
};

export default FutureDateValidator;
